
const WomenData = [
    {
        id : "1",
        schemeName: "Pradhan Mantri Matru Vandana Yojana",
        discription:"Pradhan Mantri Matru Vandana Yojana (PMMVY) is a Maternity Benefit Programme that is implemented in all the districts of the country in accordance with the provision of the National Food Security Act, 2013.",
        launchDate: "Year 2017",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Integrated child Development Scheme",
    discription:"The Integrated Child Development Service (ICDS) Scheme providing for supplementary nutrition, immunization and pre-school education to the children is a popular flagship programme of the government.",
    launchDate: " year 1975",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Scheme for Adolescent Girls",
    discription:"Adolescence is a crucial phase in the life of woman. At this stage, she stands at the threshold of adulthood.",
    launchDate: "Year 2010",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Beti  Bachao Beti Padhao",
        discription:"Social construct discriminating girls on the one hand, easy availability, affordability and subsequent misuse of diagnostic tools on the other hand, have been critical in declining CSR.",
        launchDate: "23 January 2015",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Sukanya Samriddhi Scheme",
    discription:"‘Sukanya Samriddhi Yojna’ is a small deposit scheme for girl child, launched as a part of the ‘Beti Bachao Beti Padhao’ campaign, which would fetch an attractive interest rate and provide income tax rebate.",
    launchDate: "22 January 2015", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "UJJWALA",
    discription:"A Comprehensive Scheme for Prevention of trafficking and Rescue, Rehabilitation and Re-integration of Victims of Trafficking and Commercial Sexual Exploitation.",
    launchDate: "Year 2007",
    AnualFund: "12345"
},
{   id : "7",
schemeName: "Swadhar Greh",
discription:"The scheme envisions a supportive institutional framework for women victims of difficult circumstances so that they could lead their life with dignity and conviction.",
launchDate: "Year 2002",
AnualFund: "12345"},






]
export default WomenData;